import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DropdownMenuMarkDynamicStyleType
} from "./type";

export const DROPDOWN_MENU_MARK_DOT_RATIO = 2;

const stylesheet = StyleSheet.create({
    slot: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    iconSizes,
    radiuses,
    color
}: DropdownMenuMarkDynamicStyleType) => {
    const dotSize = iconSizes.small / DROPDOWN_MENU_MARK_DOT_RATIO;

    const styles = {
        dot: {
            borderRadius: radiuses.full,
            backgroundColor: color,
            height: dotSize,
            width: dotSize
        } as ViewStyle,
        slot: {
            height: iconSizes.small,
            width: iconSizes.small
        } as ViewStyle
    };

    return styles;
};
export default stylesheet;
